import script from "./ChatRegionsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatRegionsCard.vue?vue&type=script&setup=true&lang=js"

import "./ChatRegionsCard.vue?vue&type=style&index=0&id=5bed9b8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bed9b8c"]])

export default __exports__